<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xs="12">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="pl-3 banner-title blue--text">
            Vessel Listings
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div>
            <!--<addVessel class="pr-3" />-->
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-data-table
        :headers="header"
        item-key="id"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :items="departed_vessels"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-menu offset-y bottom left>
            <template v-slot:activator="{ on }">
              <!-- <v-icon small class="mr-2;" style="cursor: pointer" v-on="on">
                mdi-dots-vertical
              </v-icon>-->
              <v-btn icon class="grey lighten-4 mx-2" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(it, i) in menu_items" :key="i">
                <v-list-item-title
                  style="cursor: pointer;"
                  class=""
                  @click="doAction({ name: it.ref, item: item })"
                >
                  {{ it.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-col>
  </v-container>
</template>

<script>
//const addVessel = () => import("./add-vessel");
import { createNamespacedHelpers } from "vuex";
const departedVessel = createNamespacedHelpers("departed_vessels");
export default {
  components: {
    // addVessel
  },
  data: () => ({
    activeItem: null,
    menu: null,
    show: false,
    filteredList: null,
    search: "",
    menu_items: [
      { title: "add new DO", ref: "add_do" },
      { title: "view DOs", ref: "view_dos" }
    //  { title: "view vessel details", ref: "view_vessel_details" }
    ]
  }),

  computed: {
    ...departedVessel.mapState({
      departed_vessels: state => state.departed_vessels,
      loading: state => state.loading
    }),
    items() {
      return [
        { vessel_name: "vessel 01", voyage_no: "123456" },
        { vessel_name: "vessel 02", voyage_no: "765432" }
      ];
    },
    header() {
      return [
        { text: "Vessel Name", value: "vessel_name" },
        { text: "Shipping Line", value: "shipping_line" },
        { text: "Vogaye No", value: "voyage_number" },
        { text: "Arrival Date", value: "arrival_date" },
        { text: "Departure Date", value: "departure_date" },
        // { text: "Departure Time", value: "departure_time" },
        { text: "Action", value: "actions", align: "end", sortable: false }
      ];
    }
  },
  mounted() {
    this.initialize();
    console.log("loading", this.loading);
  },
  methods: {
    ...departedVessel.mapActions([
      "fetchDepartedVessels",
      "asetSelectedVessel"
    ]),

    doAction(item) {
      this.asetSelectedVessel(item.item);
      if (item.name === "add_do") {
        this.$router.push("/traffic/delivery/dos/create");
      }
      if (item.name === "view_dos") {
        this.$router.push("/traffic/view-dos");
      }
      console.log("action", item);
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().indexOf(search) !== -1
      );
    },

    initialize() {
      this.fetchDepartedVessels();
    }
  }
};
</script>

<style scoped>
.list {
  width: 100%;
}
</style>
